<template>
  <div class="main-page">
    <Menus title="测试页面"></Menus>
    <div class="container-flex">
      <div style="padding:50px; background: #fff; border-radius: 20px; margin:50px; font-size: 22px;">
        <div v-for="(item,index) in list" :key="`key-test-${index}`" style="border:2px solid #ddd; margin-bottom:20px; padding:20px;">
          <div>{{item.name}}</div>
          <div style="font-size:16px;margin-bottom: 20px; color:#999;">{{item.description}}</div>
          <button @click="handleClick(item)" style="font-size: 18px;">测试</button>
        </div>
        <div><button @click="showIframe=!showIframe">{{showIframe?'关闭':'打开'}}Iframe</button></div>
      </div>
      <iframe v-if="showIframe" style="display: inline-flex;width:1920px; height:100%; margin: 0 auto;" :src="url" />
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import axios from 'axios'

export default {
  components: {
    Menus
  },
  data () {
    return {
      list: [],
      showIframe: false,
      url: ""
    }
  },
  methods: {

  },
  async mounted () {
    this.getData()

  },
  methods: {
    getData () {
      const noCacheURL = 'https://qiniu.ns.laway.cn/app/common/terminal_test_page_config.json?' + new Date().getTime();
      axios.get(noCacheURL).then(res => {
        this.list = res.data
      })
    },
    handleClick (item) {
      if (item.func) {
        const fn = new Function(item.func)()
        fn(this)
        return
      }
      if (item.url) {
        if (item.isRouter) {
          this.$router.push(item.url)
        } else {
          this.url = item.url
          this.showIframe = true
        }
      }
    }
  }
}
</script>
<style lang="stylus"></style>
